export const SET_LOADING = 'src/store/upload/SET_LOADING'
export const SET_IMAGE_RESPONSE = 'src/store/upload/SET_IMAGE_RESPONSE'
